import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_REQUEST =
  "@@customerAttributes/GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@customerAttributes/GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_FAILURE =
  "@@customerAttributes/GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_FAILURE";

export function getCustomerAttributesDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=customer_annual_consumption&organisation=${organisation}&sample_table=${sample_table}`; // customer_attributes
      }

      const response = await API.get("usimAPI", url);

      dispatch({
        type: GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_ATTRIBUTES_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_CUSTOMER_ATTRIBUTES_LIST_REQUEST =
  "@@customerAttributes/GET_CUSTOMER_ATTRIBUTES_LIST_REQUEST";
export const GET_CUSTOMER_ATTRIBUTES_LIST_SUCCESS =
  "@@customerAttributes/GET_CUSTOMER_ATTRIBUTES_LIST_SUCCESS";
export const GET_CUSTOMER_ATTRIBUTES_LIST_FAILURE =
  "@@customerAttributes/GET_CUSTOMER_ATTRIBUTES_LIST_FAILURE";

export function getCustomerAttributesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_ATTRIBUTES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=customer_annual_consumption&organisation=${organisation}&sample_table=false`; // customer_attributes
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_CUSTOMER_ATTRIBUTES_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_ATTRIBUTES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_CUSTOMER_ATTRIBUTES_LIST_REQUEST =
  "@@customerAttributes/DELETE_CUSTOMER_ATTRIBUTES_LIST_REQUEST";
export const DELETE_CUSTOMER_ATTRIBUTES_LIST_SUCCESS =
  "@@customerAttributes/DELETE_CUSTOMER_ATTRIBUTES_LIST_SUCCESS";
export const DELETE_CUSTOMER_ATTRIBUTES_LIST_FAILURE =
  "@@customerAttributes/DELETE_CUSTOMER_ATTRIBUTES_LIST_FAILURE";

export function deleteCustomerAttributesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_CUSTOMER_ATTRIBUTES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=customer_annual_consumption&organisation=${organisation}`; // customer_attributes
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_CUSTOMER_ATTRIBUTES_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_CUSTOMER_ATTRIBUTES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_CUSTOMER_ATTRIBUTES_DATA_REQUEST =
  "@@customerAttributes/UPLOAD_CUSTOMER_ATTRIBUTES_DATA_REQUEST";
export const UPLOAD_CUSTOMER_ATTRIBUTES_DATA_SUCCESS =
  "@@customerAttributes/UPLOAD_CUSTOMER_ATTRIBUTES_DATA_SUCCESS";
export const UPLOAD_CUSTOMER_ATTRIBUTES_DATA_FAILURE =
  "@@customerAttributes/UPLOAD_CUSTOMER_ATTRIBUTES_DATA_FAILURE";

export function uploadCustomerAttributesData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_CUSTOMER_ATTRIBUTES_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=customer_annual_consumption`; // customer_attributes
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/gzip" },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getCustomerAttributesList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_CUSTOMER_ATTRIBUTES_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_CUSTOMER_ATTRIBUTES_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_CUSTOMER_ATTRIBUTES_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
